import pluralize from 'pluralize'
import React, { useState } from 'react'
import { Typography } from "antd"

import { useToggle } from '../../modules'

import Modal from "../resusable/modal"
// import Amenities from './amenities'

const { Paragraph } = Typography

const Room = ({ toggle, visible, addNew, edit, item, index: key }) => {
    const [amenities, setAmenities] = useState(item?.amenities ?? [])
    const [variants, setVariants] = useState(item?.variants ?? [])
    const [name, setName] = useState(item?.name)
    const [price, setPrice] = useState(item?.price)

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            default:
                break
        }
    }

    const [amenitiesModal, toggleAmenitiesModal] = useToggle()

    const deleteIngredient = i => {
        let temp = [...amenities]
        temp = temp.filter((_, index) => i !== index)

        setAmenities(temp)
    }

    const deleteItem = i => {
        let temp = [...variants]
        temp = temp.filter((_, index) => i !== index)

        setVariants(temp)
    }

    const editName = (i, val) => {
        let temp = [...variants]
        temp[i].name = val

        setVariants(temp)
    }

    const editPrice = (i, val) => {
        if (isNaN(val))
            return 

        let temp = [...variants]
        temp[i].price = val

        setVariants(temp)
    }

    const save = () => {
        if (item) {
            edit({
                name,
                price,
                // amenities,
                variants
            }, key)
        } else {
            addNew({
                name,
                price,
                // amenities,
                variants
            })
        }
        toggle()
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            title={ item ? "Edit Room" : "Add Room" }
            toggle={toggle}
            visible={visible}>
            {/* <Amenities
                amenities={amenities}
                onSave={setAmenities}
                visible={amenitiesModal}
                toggle={toggleAmenitiesModal} /> */}
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Room Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={modify}
                            placeholder="Cottage 1" />
                    </div>
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Room Rate
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-price"
                            name="price"
                            type="number"
                            value={price}
                            onChange={modify}
                            placeholder="Ksh. XXXX" />
                    </div>
                    {/* <div className="w-full px-3 mb-3 md:mb-0">
                        <div className="font-bold mt-3">
                            <div className="flex justify-between items-center">
                                <p className="font-bold my-3">Issued Variants</p>
                                <button onClick={toggleAmenitiesModal} className="btn hisani-btn-green text-white my-3">
                                    <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                    <span className="hidden xs:block ml-2">Add</span>
                                </button>
                            </div>
                            {
                                amenities.length > 0 ?
                                    <table className="table-auto w-full mb-3">
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Selected</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Quantity</div>
                                                </th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                amenities.map((ingredient, key) =>
                                                    <tr>
                                                        <td className="p-2 text-left">{key + 1}</td>
                                                        <td className="p-2 text-left">{ingredient.name}</td>
                                                        <td className="p-2 text-left">{ingredient.qty} {pluralize(ingredient.issuedIn, ingredient.qty)}</td>
                                                        <td onClick={() => deleteIngredient(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="text-center my-4">
                                        <h3>Please click above to add items</h3>
                                    </div>
                            }
                        </div>
                    </div> */}
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <div className="font-bold mt-3">
                            <div className="flex justify-between items-center">
                                <p className="font-bold my-3">Additional Billed Items</p>
                                <button onClick={ () => setVariants([...variants, { name: 'Item 1', price: 0 }])} className="btn hisani-btn-green text-white my-3">
                                    <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                    <span className="hidden xs:block ml-2">Add</span>
                                </button>
                            </div>
                            {
                                variants.length > 0 ?
                                    <table className="table-auto w-full mb-3">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Price</div>
                                                </th>
                                                <th />
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                variants.map((itm, key) =>
                                                    <tr>
                                                        <td className="p-2 text-left">{key + 1}</td>
                                                        <td className="p-2 text-left">
                                                            <Paragraph 
                                                                editable={{
                                                                    onChange: v => editName(key, v)
                                                                }}>
                                                                { itm.name }
                                                            </Paragraph>
                                                        </td>
                                                        <td className="p-2 text-left">Ksh. 
                                                            <Paragraph 
                                                                editable={{
                                                                    onChange: v => editPrice(key, v)
                                                                }}>
                                                                { itm.price }
                                                            </Paragraph>
                                                        </td>
                                                        <td onClick={() => deleteItem(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="text-center my-4">
                                        <h3>Please click above to add items</h3>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={save} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default Room